import { render, staticRenderFns } from "./aufgaben-widget.vue?vue&type=template&id=10b601a8&scoped=true"
import script from "./aufgaben-widget.vue?vue&type=script&lang=js"
export * from "./aufgaben-widget.vue?vue&type=script&lang=js"
import style0 from "./aufgaben-widget.vue?vue&type=style&index=0&id=10b601a8&prod&scoped=true&lang=css"
import style1 from "./aufgaben-widget.vue?vue&type=style&index=1&id=10b601a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b601a8",
  null
  
)

export default component.exports